module.exports = __webpack_public_path__ + "media/images/map/6-803e229d2f6a763435bc6fec695bd00d.png";